import { render, staticRenderFns } from "./vipOptions.vue?vue&type=template&id=98d116a2&"
import script from "./vipOptions.vue?vue&type=script&lang=js&"
export * from "./vipOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98d116a2')) {
      api.createRecord('98d116a2', component.options)
    } else {
      api.reload('98d116a2', component.options)
    }
    module.hot.accept("./vipOptions.vue?vue&type=template&id=98d116a2&", function () {
      api.rerender('98d116a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/serverList/vipOptions.vue"
export default component.exports